import en from './en.locale';
import fr from './fr.locale';
export default { en, fr };
